import { css, SerializedStyles } from '@emotion/core'

import { Color } from '../../../enums/color'
import { StyledComponent } from '../../../types/styledComponent'

export const getDisabledStyle = (Control: StyledComponent, Label: StyledComponent): SerializedStyles => css`
  ${Control} {
    background-color: ${Color.Grey200};
  }

  ${Label} {
    opacity: 0.5;
  }

  cursor: not-allowed;
`
